<div class="container">

  <div class="grid container-header">

    <div class="col-12 md:col-12 lg:col-6">
      <span class="title">{{ 'TRANSLATE.NEW.PRODUCT' | translate }}</span>
    </div>
  </div>

  <div class="container-body">
    <form [formGroup]="userform" (ngSubmit)="buttonSave()">

      <div class="new-product-itens">

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-filter" for="countryNew">{{ 'TRANSLATE.COUNTRY' | translate }}</label>
            <p-dropdown [options]="listCountries" id="countryNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [autoDisplayFirst]="false" formControlName="optionCountry" (onChange)="countryChange($event)"
              [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedCountry === null && !userform.controls['optionCountry'].valid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.COUNTRY' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-second">
            <label class="element-add-edit-filter" for="statusNew">{{ 'TRANSLATE.STATUS' | translate }}</label>
            <p-dropdown [options]="listStatus" id="statusNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [autoDisplayFirst]="false" formControlName="optionStatus" (onChange)="statusChange($event)"
              [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedStatus === null && !userform.controls['optionStatus'].valid) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.STATUS' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-4 element-add-edit space-second">
            <label class="element-add-edit-label" for="productNameNew">{{ 'TRANSLATE.PRODUCT.NAME' | translate
              }}</label>
            <input class="element-add-edit-input large-text" id="productNameNew" formControlName="inputProductName"
              type="text" maxlength="50" pInputText>

            @if (hasControlRequiredError('inputProductName')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.NAME.PRODUCT' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputProductName')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.PRODUCT.NAME' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first top-space">
            <label class="element-add-edit-label" for="productCodeNew">{{ 'TRANSLATE.PRODUCT.SYMBOL' | translate
              }}</label>
            <input class="element-add-edit-input short-text" id="productCodeNew" formControlName="inputCode" type="text"
              maxlength="10" pInputText (keyup)="productCodeOnKeyUp($event)">

            @if (userform.controls['inputCode'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.PRODUCT.SYMBOL' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-second top-space">
            <label class="element-add-edit-label" for="visitNew">{{ 'TRANSLATE.VISIT' | translate }}</label>
            <input class="element-add-edit-input short-text " id="visitNew" formControlName="inputVisits" type="text"
              (input)="formatNumber($event)" maxlength="2" pInputText>

            @if (userform.controls['inputVisits'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.NUMBER.VISITS' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-second top-space">
            <label class="element-add-edit-label" for="monthsNew">{{ 'TRANSLATE.MONTHS' | translate }}</label>
            <input class="element-add-edit-input short-text" id="monthsNew" formControlName="inputMonths" type="text"
              maxlength="3" (input)="onMonthsInput($event)" pInputText>

            @if (hasControlRequiredError('inputMonths')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.MONTHS' | translate }}">
            </p-message>
			} @else if (hasControlGreaterThanZeroError('inputMonths')) {
			<p-message class="client-data-message" severity="error"
			  text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
			</p-message>
            }
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first top-space">
            <label class="element-add-edit-label" for="distanceNew">{{ 'TRANSLATE.DISTANCE' | translate }}</label>
            <input class="element-add-edit-input short-text" id="distanceNew" formControlName="inputDistance" type="text"
              maxlength="7" (input)="onDistanceInput($event)" pInputText>

            @if (hasControlRequiredError('inputDistance')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DISTANCE' | translate }}">
            </p-message>
			} @else if (hasControlGreaterThanZeroError('inputDistance')) {
			<p-message class="client-data-message" severity="error"
			  text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
			</p-message>
            }
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">
          <div class="col-12 md:col-12 lg:col-12 element-add-edit space-first textarea-row">
            <label class="element-add-edit-label" for="productDescriptionNew">{{ 'TRANSLATE.DESCRIPTION' | translate
              }}</label>
            <textarea class="element-add-edit-input large-text" id="productDescriptionNew"
              formControlName="inputDescriptionProduct" type="text" maxlength="300" pInputTextarea></textarea>

            <div class="char-counter">
              {{ userform.get('inputDescriptionProduct')?.value?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.300' |
              translate }}
            </div>
            @if (hasControlRequiredError('inputDescriptionProduct')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.PRODUCT' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputDescriptionProduct')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.PRODUCT.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-filter" for="accountNew">{{ 'TRANSLATE.ACCOUNT.ENGLISH' | translate
              }}</label>
            <p-dropdown [options]="listAccountCodeOWS" optionLabel="label" optionValue="value" id="accountNew"
              [autoDisplayFirst]="false" [showClear]="true" formControlName="optionAccount"
              (onChange)="accountOnChange($event)"
              [placeholder]="(placeholderAccountCode || 'TRANSLATE.SELECT') | translate" [editable]="editableAccount"
              [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>
            @if (messageAccountCode === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-third">
            <label class="element-add-edit-filter" for="actionCodeNew">{{ 'TRANSLATE.ACTION.ENGLISH' | translate
              }}</label>
            <p-dropdown [options]="listActionCodeOWS" optionLabel="label" optionValue="value" id="actionCodeNew"
              [autoDisplayFirst]="false" [showClear]="true" formControlName="optionActionCode"
              (onChange)="actionCodeOnChange($event)"
              [placeholder]="(placeholderActionCodeOWS || 'TRANSLATE.SELECT') | translate"
              [editable]="editableActionCodeOWS" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>
            @if (messageActionCodeOWS === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }

          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-third">
            <label class="element-add-edit-filter" for="coverageCodeNew">{{ 'TRANSLATE.COVERAGE.ENGLISH' | translate
              }}</label>
            <p-dropdown [options]="listCoverageCodeOWS" optionLabel="label" optionValue="value" id="coverageCodeNew"
              [autoDisplayFirst]="false" [showClear]="true" formControlName="optionCoverageCode"
              (onChange)="coverageCodeOnChange($event)"
              [placeholder]="(placeholderCoverageCodeOWS || 'TRANSLATE.SELECT') | translate"
              [editable]="editableCoverageCodeOWS" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>
            @if (messageCoverageCodeOWS === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first top-space">
            <label class="element-add-edit-filter" for="insuranceCodeNew">{{ 'TRANSLATE.INSURANCE.ENGLISH' | translate
              }}</label>
            <p-dropdown [options]="listInsuranceCode" optionLabel="label" optionValue="value" id="insuranceCodeNew"
              [autoDisplayFirst]="false" [showClear]="true" formControlName="optionInsuranceCode"
              (onChange)="insuranceCodeOnChange($event)"
              [placeholder]="(placeholderInsuranceCode || 'TRANSLATE.SELECT') | translate"
              [editable]="editableInsuranceCode" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>
            @if (messageInsuranceCode === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
            @if (submitted && userform.controls['optionInsuranceCode'].invalid) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.INSURANCE.CODE' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-third">
            <label class="element-add-edit-label" for="invoiceMonthsNew">{{ 'TRANSLATE.INVOICE.ENGLISH' | translate
              }}</label>
            <p-dropdown [options]="rateCurves" optionLabel="months" optionValue="rateId" id="rateCurveNew"
              [autoDisplayFirst]="false" [showClear]="true" formControlName="optionRateCurve"
              (onChange)="rateCurveOnChange($event)" [placeholder]="placeholderRateCurve | translate"
              [style]="{'minWidth':'100%'}">
          
              <ng-template pTemplate="item" let-item>
                {{ item?.months }}
              </ng-template>
          
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.months ? item.months : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
          
            </p-dropdown>
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">
          <div class="col-12 md:col-12 lg:col-12 element-add-edit space-first textarea-row">
            <label class="element-add-edit-label" for="productDetailsNew">
              {{ 'TRANSLATE.PRODUCT.DETAILS' | translate }}
            </label>
            <textarea class="element-add-edit-input large-text" id="productDetailsNew" type="text" maxlength="1000"
              formControlName="inputProductDetails" pInputTextarea (input)="onProductDetailsInput()"
              (focus)="onProductDetailsFocus()" (blur)="onFinalOptionalFieldsBlur()"></textarea>

            <div class="char-counter">
              {{ userform.get('inputProductDetails')?.value?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.1000' |
              translate }}
            </div>
          </div>
        </div>

      </div>

      <div class="actions-section">
        <div class="col-11 md:col-11 lg:col-11 button-position">

          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonReturn()"
            [disabled]="isSaving">
            <i class="pi pi-arrow-left"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>

          <app-cta-button [label]="'TRANSLATE.SAVE'" [loadingLabel]="'TRANSLATE.SAVING'" [successState]="isCtaSuccess"
            [loading]="isSaving" (buttonClick)="buttonSave()">
          </app-cta-button>

        </div>
      </div>

    </form>
  </div>

</div>